import React, { useState, useEffect } from 'react';
import './stylesheet/customLogin.css';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { signIn, signOut } from 'aws-amplify/auth';

import AppShell from './AppShell';
import { CustomSignIn } from './CustomSignIn';
import CustomSignUp from './CustomSignUp';
import ForgotPassword from './ForgotPassword';
import ForgotUsername from './ForgotUsername';
import ConfirmUser from '../ConfirmUser/confirmUser';
import PaymentSuccess from './PaymentSuccess';
import PublicAgentChatPage from '../pages/PublicAgentChatPage';
import PublicFormPage from '../pages/forms/PublicFormPage';
import FormFlowPage from '../pages/forms/FormFlow/FormFlowPage';
function AuthLayout({ children }) {
  return (
    <div className="auth-layout">
      <div className="auth-form-panel">
        {children}
      </div>
    </div>
  );
}

function PromptRedirect({ children }) {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const prompt = params.get('prompt');

  if (prompt && location.pathname !== '/signUp') {
    return <Navigate to={`/signUp?prompt=${encodeURIComponent(prompt)}`} replace />;
  }

  return children;
}

function AuthWrapper({ authState, onStateChange, user, isAuthLoading }) {
  const [username, setUsername] = useState('');

  useEffect(() => {
    if (user) {
      setUsername(user.username);
    }
  }, [user]);

  const updateUsername = newUsername => {
    setUsername(newUsername);
  };

  const handleSignIn = async (username, password) => {
    try {
      const user = await signIn({ username, password });
      onStateChange('signedIn', user);
    } catch (error) {
      console.error('Error signing in:', error);
    }
  };

  const handleSignOut = async () => {
    try {
      await signOut();
      onStateChange('signIn', null);
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const loggedIn = authState === 'signedIn';

  return (
    <Routes>
      <Route path="/agent-form/:token" element={<PublicFormPage />} />
      <Route path="/agent-chat/:token" element={<PublicAgentChatPage />} />
      <Route path="/dynamic-form/:componentId/:instanceId" element={<PublicFormPage />} />
      <Route path="/dynamic-form/:componentId" element={<PublicFormPage />} />
      <Route path="/form-flow/:formSessionId" element={<FormFlowPage />} />
      <Route path="/form-flow-test/:formSessionId" element={<FormFlowPage testMode />} />

      {isAuthLoading ? (
        <Route path="/*" element={<div className="loadingGif" />} />
      ) : !loggedIn ? (
        <>
          <Route path="/signUp" element={<AuthLayout><CustomSignUp formState="signUp" /></AuthLayout>} />
          <Route path="/forgotPassword" element={<AuthLayout><ForgotPassword /></AuthLayout>} />
          <Route path="/forgotUsername" element={<AuthLayout><ForgotUsername /></AuthLayout>} />
          <Route path="/confirmUser" element={<ConfirmUser />} />
          <Route
            path="/*"
            element={
              <PromptRedirect>
                <AuthLayout>
                  <CustomSignIn
                    authState={authState}
                    updateUsername={updateUsername}
                    onSignIn={handleSignIn}
                    onStateChange={onStateChange}
                    firstLogin={() => {}}
                  />
                </AuthLayout>
              </PromptRedirect>
            }
          />
        </>
      ) : (
        <Route
          path="/*"
          element={
            <AppShell
              authState={authState}
              updateUsername={updateUsername}
              onSignOut={handleSignOut}
              onStateChange={onStateChange}
            />
          }
        />
      )}
    </Routes>
  );
}

export default AuthWrapper;
